import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ContentPreloader from '../Preloader/ContentPreloader';

export default class ContentModal extends React.Component {
  static defaultProps = {
    visible: false,
  };

  static propTypes = {
    visible: PropTypes.bool.isRequired,
    src: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    extension: PropTypes.string,
    hide: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.root = document.createElement('div');
    document.body.appendChild(this.root);
  }

  componentWillUnmount() {
    document.body.removeChild(this.root);
  }

  render() {
    const {
      visible, src, name, type, extension,
    } = this.props;

    return ReactDOM.createPortal(
      <div
        className="modal-layout"
        style={{ display: visible ? 'block' : 'none' }}
        onClick={(e) => {
          if (e.currentTarget == e.target) this.props.hide();
        }}
      >
        <div className="modal-main -content">
          <div className="modal-content">
            <h2 className="modal-title">{name}</h2>

            <div className="modal__content">
              {type === 'image' ? <img src={src} alt="" /> : ''}
              {type === 'vimeoVideo' ? (
                <div className="video-player video-player--modal">
                  <ContentPreloader />
                  <iframe
                    className="video-player__frame"
                    src={src}
                    title={name}
                    frameBorder="0"
                    allowFullScreen={true}
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                  />
                </div>
              ) : (
                ''
              )}
              {type === 'video' ? (
                <div className="video-player video-player--modal">
                  <ContentPreloader />
                  <video className="video-player__frame" controls>
                    {extension === 'mp4' ? (
                      <source src={src} type={`video/${extension}`} />
                    ) : (
                      <source src={src} />
                    )}
                    {'Ошибка: Ваш браузер не поддерживает воспроизведение видео.'}
                  </video>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>

          <div className="modal-close" onClick={this.props.hide}>
            {'Закрыть всплывающее окно'}
          </div>
        </div>
      </div>,

      this.root,
    );
  }
}
